// ─── Глобальные дизайн-токены ─────────────────────────────────────────────────
// Перенесено из Digital Twin (1).html — холодная серебряная тема

export const C = {
  bg:          '#05050d',
  bg2:         '#08081a',
  surface:     'rgba(255,255,255,0.028)',
  surface2:    'rgba(255,255,255,0.04)',
  border:      'rgba(180,185,230,0.09)',
  borderHi:    'rgba(180,185,230,0.2)',
  silver:      '#b8bdd4',
  silverLo:    '#8890aa',
  silverHi:    '#dce0f0',
  silverGlow:  'rgba(180,185,230,0.12)',
  green:       '#4dc88a',
  orange:      '#e09858',
  red:         '#d45a5a',
  purple:      '#9b7fd4',
  gold:        '#e0b84a',
  // алиасы для совместимости
  text:        '#dce0f0',
  textMuted:   '#8890aa',
  accent:      '#b8bdd4',
  accentDim:   'rgba(180,185,230,0.12)',
}

export const font = {
  heading: "'Cormorant Garamond', serif",
  mono:    "'Space Mono', monospace",
  body:    "'Inter', sans-serif",
}

// CSS-класс стилей для карточки
export const cardStyle = {
  background:   C.surface,
  border:       `1px solid ${C.border}`,
  borderRadius: 10,
  padding:      22,
  position:     'relative',
  overflow:     'hidden',
  transition:   'border-color 0.3s',
}

export const cardLabel = {
  fontFamily:    font.mono,
  fontSize:      9,
  letterSpacing: '0.14em',
  textTransform: 'uppercase',
  color:         C.silverLo,
  marginBottom:  16,
}

export const btnSm = {
  padding:      '5px 14px',
  borderRadius: 20,
  cursor:       'pointer',
  fontFamily:   font.body,
  fontSize:     11.5,
  fontWeight:   400,
  letterSpacing: '0.04em',
  background:   'transparent',
  border:       `1px solid ${C.border}`,
  color:        C.silverLo,
  transition:   'all 0.2s',
}

export const btnSmActive = {
  ...btnSm,
  borderColor: C.borderHi,
  color:       C.silverHi,
  background:  C.silverGlow,
}

export const tagStyle = {
  padding:      '3px 9px',
  borderRadius: 3,
  border:       `1px solid ${C.border}`,
  fontFamily:   font.body,
  fontSize:     10.5,
  color:        C.silverLo,
  letterSpacing: '0.03em',
  background:   C.surface,
  display:      'inline-block',
  marginRight:  4,
  marginBottom: 4,
}
